import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { mapEquipmentDtoArray } from '../../../mapping/rooms'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

export default function useGetEquipmentList() {
  const texts = useTranslation().t

  const query = useQuery([queryNames.getEquipmentList], async () => {
    const { data } = await dataApi.getEquipmentList()
    return mapEquipmentDtoArray(data)
  }, {
    staleTime: Infinity,
    refetchOnMount: 'always',
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })

  return query
}
